var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2384 4.98241L11.5223 18.6975C10.5066 19.7134 8.85899 19.7134 7.84234 18.6975L0.761997 11.6167C-0.254081 10.6008 -0.254081 8.95299 0.761997 7.93691C1.77827 6.92064 3.42575 6.92064 4.44158 7.93653L9.68286 13.1779L21.5582 1.30244C22.5745 0.286171 24.2221 0.286941 25.238 1.30244C26.2539 2.31852 26.2539 3.96575 25.2384 4.98241Z",
    fill: "#0056CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBlue);
export default __webpack_public_path__ + "static/media/check-blue.9cbba87b.svg";
export { ForwardRef as ReactComponent };